<template>
    <section class="background">
        <header>
            <div class="container clearfix">
                <img height="40px" src="../../../assets/logo.png" />
                <h3 style="color:#FFF;">{{$t('index.login.title')}}{{$t('components.editTable.indexCol')}}</h3>
                <nav>
                    <span>IT服务热线：4008085000</span>
                    <a href="javascript:void" class="qcode">
                        <i class="el-icon-mf mf-qrcode"></i>
                        <ul>
                            <li>
                                <img src="../../../assets/u18.png" width="200" />
                                <h5 :title="$t('index.login.scanCodeDownload') + $t('index.login.mideaThrough')">{{$t('index.login.scanCodeDownload')}}<strong>{{$t('index.login.mideaThrough')}}</strong></h5>
                            </li>
                        </ul>
                    </a>

                    <a href="javascript:void(0)" class="globalization">
                        <i class="el-icon-mf mf-globe"></i><span>{{currentLang}}</span>
                        <ul>
                            <li v-for="(lang, index) in languages" :key="index" :style="{fontWeight: currentLang === lang.name ? 'bold' : 'normal'}">
                                <a @click="languageChange(lang.name)">
                                    <span>{{lang.label}}</span>
                                </a>
                            </li>
                        </ul>
                    </a>
                </nav>
            </div>
        </header>
        <div class="login-container">
            <div class="login-panel">
                <Card>
                    <div v-if="!isLogin" class="login-step1">
                        <div class="login-panel-head">
                            <div class="logo"></div>
                            <p class="name">{{$t('index.login.visitor')}}</p>
                        </div>
                        <div class="login-panel-links">
                            <a class="fl" href="javascript:;" @click="forgetPassword">{{$t('index.login.forgetPassword')}}</a>
                            <a class="fr" href="javascript:;" @click="goRegister">{{$t('index.login.register')}}</a>
                        </div>
                        <div class="login-panel-tool">
                            <Button style="width:100%;" type="primary" @click="goLogin">{{$t('index.login.login')}}</Button>
                        </div>
                    </div>
                    <div v-else class="login-step2">
                        <div class="login-panel-head">
                            <div class="logo"></div>
                            <p class="name">{{userName}}</p>
                        </div>
                        <div class="login-panel-links">
                            <a class="fr" href="javascript:;" @click="outLogin">{{$t('index.login.loginOut')}}</a>
                        </div>
                        <div class="login-panel-tool">
                            <Button style="margin-bottom:10px;width:100%;" v-if="!isPro" type="primary" @click="goGsc" :loading="loading">进入新系统（测试环境专用）</Button>
                            <Button style="width:100%;" type="primary" @click="goSystem" :loading="loading">{{$t('index.login.loginBtn')}}</Button>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
        <swiper :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide class="banner-img6">
                <div @click="swiperGo(6)" class="swiper-link"></div>
            </swiper-slide>
            <swiper-slide class="banner-img8">
                <div class="swiper-link"></div>
            </swiper-slide>
            <swiper-slide class="banner-img5">
                <div @click="swiperGo(5)" class="swiper-link"></div>
            </swiper-slide>
            <swiper-slide class="banner-img1">
                <div @click="swiperGo(1)" class="swiper-link"></div>
            </swiper-slide>
            <swiper-slide class="banner-img2">
                <div @click="swiperGo(2)" class="swiper-link"></div>
            </swiper-slide>
            <swiper-slide class="banner-img3">
                <div @click="swiperGo(3)" class="swiper-link"></div>
            </swiper-slide>
            <swiper-slide class="banner-img4">
                <div @click="swiperGo(4)" class="swiper-link"></div>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="index-bg">
            <div id="icon-bar">
                <div class="container clearfix">
                    <ul>
                        <li><img src="../../../assets/u9.png" /><p>全球共享</p></li>
                        <li><img src="../../../assets/u8.png" /><p>构建生态</p></li>
                        <li><img src="../../../assets/u6.png" /><p>公开透明</p></li>
                        <li><img src="../../../assets/u7.png" /><p>合作共赢</p></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="index-news-bg">
            <div class="index-news-layout">
                <div class="item">
                    <div class="title">
                        <h2>帮助指引</h2>
                        <a href="" @click.stop.prevent="toHelper">更多&gt;&gt;</a>
                    </div>
                    <img @click="toHelper" src="../../../assets/u88.png" width="300"/>
                </div>
                <div class="item">
                    <div class="title">
                        <h2>美的新闻</h2>
                        <a href="http://www.midea.com/midea-page/news-list.html" target="_blank">更多&gt;&gt;</a>
                    </div>
                    <a href="http://www.midea.com/midea-page/news-list.html" target="_blank"><img src="../../../assets/u56.png" width="300" /></a>
                </div>
                <div class="item">
                    <div class="title">
                        <h2>廉政美的</h2>
                        <a   @click.stop.prevent="toIntegrityMidea"  target="_blank">更多&gt;&gt;</a>
                    </div>
                    <a  @click.stop.prevent="toIntegrityMidea"  target="_blank"><img src="../../../assets/u90.png" width="300" /></a>
                    <p>欢迎各位供应商朋友对美的供应链中的不合规行为进行投诉美的全球廉正与合规举报渠道：compliance@midea.com</p>
                </div>
            </div>
        </div>
        <footer>
            <div class="container clearfix">
                <div class="pull-left">
                    <ul class="clearfix">
                        <li>
                            <router-link to="/websiteinfo/serviceterm">{{$t('index.login.termsOfService')}}</router-link>
                        </li>
                        <li>|</li>
                        <li>
                            <router-link to="/websiteinfo/privatepolicy">{{$t('index.login.privacyPolicy')}}</router-link>
                        </li>
                        <li>|</li>
                        <li>
                            <router-link to="/websiteinfo/contactus">{{$t('index.login.contractUs')}}</router-link>
                        </li>
                        <li>|</li>
                        <li>
                            <router-link to="/websiteinfo/complaintCenter">{{$t('index.login.complaintCenter')}}</router-link>
                        </li>
                    </ul>
                    <p class="copyright">Copyright &copy; 1968-{{(new Date()).getFullYear()}} {{$t('index.login.midea')}} {{$t('index.login.copyright')}}</p>
                </div>
                <div class="pull-right">
                    <ul class="clearfix">
                        <li>
                            <a target="_blank" href="http://www.midea.com/cn">{{$t('index.login.midea')}}</a>
                        </li>
                        <li>|</li>
                        <li>
                            <a target="_blank" href="http://www.littleswan.com/">{{$t('index.login.littleswan')}}</a>
                        </li>
                        <li>|</li>
                        <li>
                            <a target="_blank" href="https://www.annto.com">{{$t('index.login.annto')}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>

        <Modal
            v-model="modal1"
            :title="$t('index.login.loginOutTitle')"
            @on-ok="loginFn"
            width="400"
            @on-cancel="modal1 = false">
            <p>{{$t('index.login.loginOutTips')}}</p>
        </Modal>
    </section>
</template>
<script>
    import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper';
    import axios from 'axios';
    import { switchLang } from '@/common/js/user';
    import api from '@/modules/index/api/gsc';
    import { logout, clearCookie, htmlEncode } from '@/utils/index';
    export default {
        components: {
            swiper,
            swiperSlide
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper;
            }
        },
        data() {
            return {
                isPro: false,
                vendorInfo: {
                    vendorCode: '',
                    vendorId: ''
                },
                hostname: location.hostname,
                orgType: '',
                toGscOrGsrmUrl: '/gscapp/sys/sysOrganizations/toGscOrGsrm',
                loading: false,
                modal1: false,
                orgList: [],
                title1: '',
                title2: '',
                title3: '',
                canScrollTimer: 0,
                newList: [],
                newList2: [],
                thisUrl: window.location.href,
                swiperOption: {
                    notNextTick: true,
                    grabCursor: false,
                    setWrapperSize: false,
                    pagination: '.swiper-pagination',
                    paginationClickable: true,
                    speed: 2000,
                    observer: true,
                    observeParents: true,
                    autoplay: 5000,
                    autoplayDisableOnInteraction: false,
                    simulateTouch: false
                },
                currentLang: this.$i18n.locale,
                formInline: {
                    user: 'SA000015801',
                    password: 'Abcd123456'
                },
                languages: [
                    {
                    name: 'zh-CN',
                    label: '中文'
                }, {
                    name: 'en-US',
                    label: 'EN'
                }, {
                    name: 'ja-JP',
                    label: '日本語',
                }],
                sourceList: [],
                resultList: [],
                demandList: [],
                total1: 0,
                current1: 1,
                pageSize1: 10,
                total2: 0,
                current2: 1,
                pageSize2: 10,
                total3: 0,
                current3: 1,
                pageSize3: 10,
                isLogin: false,
                userName: '',
                runTimer: null,
                vendorCode: null,
                vendorId: null,
                userName2: null
            };
        },
        methods: {
            swiperGo (type) {
                switch (type) {
                    case 1 :
                        break;
                    case 2 :
                        break;
                    case 3 :
                        break;
                    case 4 :
                        break;
                    case 5 :
                        break;
                }
            },
            outLogin () {
                this.modal1 = true;
            },
            loginFn () {
                logout().then(() => {
                    this.isLogin = false;
                    window.location.href = htmlEncode(`${api.logoutUrl}?service=${this.thisUrl}`);
                });
            },
            async checkLoginStatus () {
                try {
                    await axios.post('/gscint/vendor/getCurrentVendor').then(res => {
                        let data = res.data;
                        if (data.success) {
                            localStorage.setItem('supplierInfo', JSON.stringify(data.data));
                            this.userName = data.data.userName;
                        }
                    });
                    this.isLogin = true;
                    this.loading = true;
                    // 加载资源
                    this.getCss('/mideaPrint/resources/fineReport.css');
                    axios.get('/gscapp/lov/getOULovNew?UP=N&SITE=Y&ASL=N&labelName=ouName&valueName=ouCode').then((res) => {
                        this.loading = false;
                        if (res.data.success) {
                            if (res.data.data) {
                                this.orgList = this.orgList.concat(res.data.data);
                                let ids = [];
                                res.data.data.map((item) => {
                                    ids.push(item.value);
                                });
                                let fromData = new FormData();
                                fromData.append('organCodes', ids.toString());
                                axios.post(this.toGscOrGsrmUrl, fromData).then((res2) => {
                                    let req = res2.data.data.status;
                                    if (req === 'gsrm') {
                                        this.orgType = 'gsrm';
                                    } else {
                                        this.orgType = 'gsc';
                                    }
                                });
                            } else {
                                this.orgType = 'gsc';
                            }
                        } else {
                            this.orgType = 'gsc';
                        }
                    });
                } catch (error) {
                    if (error.status === 401) {
                        this.isLogin = false;
                    }
                }
            },
            getCss(url) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = url;
                document.body.appendChild(link);
            },
            insertParamToLog () {
                axios.post('/gscapp/log/send', {
                    vendorId: this.vendorInfo.vendorId,
                    vendorCode: this.vendorInfo.vendorCode
                });
                axios.post('/gscapp/switchAccountOfOperation/logoutAccount', {
                    uuidNum: localStorage.getItem('UUID_NUM'),
                    vendorCode: localStorage.getItem('vendorCode')
                });
            },
            goSystem () {
                this.insertParamToLog();
                if (this.orgType === 'gsc') {
                    this.initSystem();
                } else {
                    window.location.href = api.gsrmUrl;
                }
            },
            goSrm () {
                window.location.href = api.gsrmUrl;
            },
            goGsc () {
                this.insertParamToLog();
                this.initSystem();
            },
            initSystem () {
                this.$store.dispatch('initSystem').then(res => {
                    window.location.href = `//${window.location.host}/int/globalprotal.html`;
                }, err => {
                    this.$Message.info({
                        content: '系统初始化出错：' + err,
                        duration: 0,
                        closable: true,
                    });
                });
            },
            goLogin () {
                window.location.href = htmlEncode(`${api.logoutUrl}?service=${api.loginUrl}?service=${this.thisUrl}`);
            },
            forgetPassword () {
                window.open(api.forgetPasswordUrl);
            },
            goRegister () {
                window.open(this.isPro ? `https://${location.hostname}/gn/#/register` : 'https://gscuat.midea.com/#/register');
            },
            toHelper: function () {
              window.open(`${this.isPro ? `https://${location.hostname}/gn/` : 'https://gscuat.midea.com/'}#/helper?name=name1`);
            },
            toIntegrityMidea: function() {
              window.open(`${this.isPro ? `https://${location.hostname}/gn/` : 'https://gscuat.midea.com/'}#/helper?name=name3`);
            },
            languageChange (name) {
                switch (name) {
                    case 'logout':
                    logout();
                    break;
                    case 'zh-CN':
                    case 'en-US':
                    case 'ja-JP':
                    switchLang(name).then(success => {
                        if (success) {
                        this.$store.dispatch('UPDATE_LANG');
                        this.$router.go(0);
                        } else {
                        this.$Message.error('语言切换失败');
                        }
                    }, () => {
                        this.$Message.error('语言切换失败');
                    });
                    break;
                    default:
                    break;
                }
            }
        },
        mounted() {
            this.currentLang = this.$i18n.locale;
            this.checkLoginStatus();
            this.isPro = window.environment.isPro;
        }
    };
</script>
<style lang='less' scoped>
    @import url("./swiper.css");
    .index-news-bg {
        padding-top: 20px;
        background: #F8F8F8;
    }
    .index-news-layout {
        width: 1200px;
        margin: 0 auto 30px;
        overflow: hidden;
        .item {
            float: left;
            width: 400px;
            box-sizing: border-box;
            padding: 0 50px;
            border-right: 1px solid #CCC;
            .title {
                position: relative;
                line-height: 35px;
                h2 {
                    font-size: 20px;
                }
                a {
                    position: absolute;
                    right: 0;
                    top: 0;
                    color: #999;
                    font-size: 12px;
                }
            }
            p {
                margin-top: 5px;
            }
        }
        .item:last-child {
            border-right: none;
        }
    }
    .swiper-container {
        height: 450px;
        .swiper-slide {
            height: 450px;
            background-position: center 0;
        }
        .swiper-link {
            position: relative;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
            background-color: transparent;
        }
        .banner-img1 {
            background-image:url('../../../assets/banner1.jpg')
        }
        .banner-img2 {
            background-image:url('../../../assets/banner2.jpg')
        }
        .banner-img3 {
            background-image:url('../../../assets/banner3.jpg')
        }
        .banner-img4 {
            background-image:url('../../../assets/banner4.jpg')
        }
        .banner-img5 {
            background-image:url('../../../assets/banner5.jpg')
        }
        .banner-img6 {
            background-image:url('../../../assets/IMG20190924-173617.jpg')
        }
        .banner-img7 {
            background-image:url('../../../assets/banner7.jpg')
        }
        .banner-img8 {
            background-image:url('../../../assets/banner8.jpg')
        }
    }
    section {
        height: 100%;
        width: 100%;
        min-width: 1000px;
        min-height: 500px;
        .title {
            margin-bottom: 20px;
            font-size: 14px;
            font-weight: 700;
            font-family: "微软雅黑";
            color: #000000;
        }
        .login-tip {
            font-size: 10px;
            text-align: center;
            color: #c3c3c3;
        }
        .login-container {
            width: 1000px;
            position: relative;
            margin: 0 auto;
            .login-panel {
                position: absolute;
                z-index: 2;
                right: 0px;
                top: 80px;
                min-width: 320px;
            }
            .login-panel-head {
                text-align: center;
                width: 200px;
                margin: 0 auto;
                padding-bottom: 20px;
                border-bottom: 1px solid #AFAFAF;
                .logo {
                    width: 80px;
                    height: 80px;
                    margin: 10px auto;
                    background: url('../../../assets/u464.png') no-repeat center;
                    border: 1px solid #AFAFAF;
                    border-radius: 50%;
                }
                .name {
                    font-size: 16px;
                    font-weight: bold;
                }
            }
            .login-panel-links {
                width: 200px;
                margin: 0 auto;
                line-height: 40px;
                height: 40px;
                .fl {
                    float: left;
                }
                .fr {
                    float: right;
                }
                a {
                    color: #169bd5;
                }
            }
            .login-panel-tool {
                padding-bottom: 30px;
                text-align: center;
                .m-btn-primary {
                    width: 200px;
                    height: 36px;
                }
            }
            .login-step2 {
                .logo {
                    background-image: url('../../../assets/u473.png');
                    border-color: #3AA2EB;
                }
                .login-panel-tool, .m-dropdown, .m-btn-primary{
                    width: 300px;
                }
                .m-dropdown-item {
                    overflow: hidden;
                    width: 300px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: left;
                }
            }
        }
        footer {
            padding: 24px 0;
            text-align: center;
            background: #323232;
            color: #5D5D5D;
            font-size: 12px;
            &>.container {
                width: 1000px;
                margin: 0 auto;
                ul {
                    li {
                        float: left;
                        font-size: 10px;
                        padding-right: 10px;
                        &:last-child {
                            padding: 0;
                        }
                        a {
                            display: block;
                            color: #B3B5BA;
                            font-size: 12px;
                        }
                    }
                }
                .copyright {
                    margin-top: 10px;
                    text-align: left;
                }
            }
        }
        header {
            font-size: 16px;
            color: #FFF;
            height: 50px;
            border-bottom: 1px solid #efefef;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 1000;
            &>.container {
                width: 1000px;
                margin: auto;
                &>img {
                    float: left;
                    margin: 5px 12px 5px 0;
                }
                &>h3 {
                    float: left;
                    font-size: 14px;
                    line-height: 35px;
                    margin-top: 15px;
                }
                &>nav {
                    float: right;
                    &>span {
                        float: left;
                        font-size: 14px;
                        line-height: 50px;
                    }
                    &>a {
                        float: left;
                        padding: 13px 25px;
                        display: block;
                        position: relative;
                        color: #FFF;
                        line-height: 100%;
                        &:last-child {
                            margin-right: 0;
                        }
                        &>span {
                            font-size: 14px;
                            margin-left: 5px;
                            line-height: 24px;
                        }
                        &>i {
                            font-size: 24px;
                            float: left;
                        }
                        &>ul {
                            position: absolute;
                            z-index: 1000;
                            top: 50px;
                            background: #FFF;
                            cursor: default;
                            display: none;
                            left: -65px;
                            color: #000;
                            text-align: center;
                            line-height: 25px;
                            &:before {
                                content: "";
                                border-top: 8px solid transparent;
                                border-left: 8px solid transparent;
                                border-right: 8px solid transparent;
                                border-bottom: 8px solid #FFF;
                                position: absolute;
                                top: -16px;
                                left: 50%;
                                transform: translate(-50%, 0);
                            }
                        }
                        &:hover {
                            ul {
                                display: block;
                            }
                        }
                        &.globalization {
                            &>ul {
                                width: 100px;
                                text-align: center;
                                left: -10px;
                                border-radius: 4px;
                                li {
                                    &:first-child {
                                        span {
                                            border-radius: 4px 4px 0px 0px;
                                        }
                                    }
                                    &:last-child {
                                        span {
                                            border-radius: 0px 0px 4px 4px;
                                        }
                                    }
                                    font-size: 13px;
                                    &>a {
                                        padding: 10px;
                                        color: #9D9D9D;
                                        display: block;
                                    }
                                }
                            }
                        }
                        &:first-child {
                            ul {
                                left: -28px;
                                width: 130px;
                                padding: 0 5px;
                                border-radius: 2px;
                                box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
                                li {
                                    float: left;
                                    padding: 10px;
                                    &>img {
                                        width: 100px;
                                    }
                                    &>h5 {
                                        text-align: center;
                                        font-size: 12px;
                                        font-weight: 400;
                                        line-height: 1em;
                                        color: #777;
                                        margin-top: 5px;
                                        width: 100px;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        &>strong {
                                            color: #333;
                                            margin-left: 2px;
                                            font-family: "微软雅黑";
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .bold {
                    padding: 10px;
                    color: #5EB3F9;
                    background: #E5F4FF;
                    display: block;
                }
            }
        }
        &>#news-bar {
            height: 50px;
            background: #F8F8F8;
            &>.container {
                width: 1000px;
                margin: auto;
                padding: 0 60px 0 35px;
                position: relative;
                &>ul {
                    white-space: nowrap;
                    &>#scrollBox {
                        overflow: hidden;
                        &>.scrollWrap {
                            width: 500%;
                            float: left;
                            &>.scrollPanel {
                                float: left;
                                &>li {
                                    position: relative;
                                    font-size: 14px;
                                    vertical-align: middle;
                                    line-height: 50px;
                                    margin-right: 50px;
                                    white-space: nowrap;
                                    display: inline-block;
                                    padding-left: 15px;
                                    &:before {
                                        content: '•', ;
                                        color: #009DD9;
                                        position: absolute;
                                        font-size: 25px;
                                        top: 2px;
                                        left: 0;
                                    }
                                    &>a {
                                        text-decoration: none;
                                        color: #999;
                                        font-size: 12px;
                                        &:hover {
                                            text-decoration: underline;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                &>i {
                    font-size: 24px;
                    position: absolute;
                    top: 0;
                    left: 5px;
                    height: 50px;
                    line-height: 50px;
                }
                &>a {
                    position: absolute;
                    top: 0;
                    right: 0px;
                    height: 50px;
                    line-height: 50px;
                    font-weight: bold;
                    color: #2A3C59;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
        .index-bg {
            background: #FFF;
        }
        #icon-bar {
            .container {
                width: 1000px;
                margin:40px auto;
                ul {
                    overflow: hidden;
                    li {
                        float: left;
                        width: 250px;
                        text-align: center;
                        font-size: 22px;
                    }
                }
            }
        }
        .panel-bar {
            background: #FFF;
            padding: 0px 0 20px 0;
            &>.container {
                width: 1000px;
                margin: auto;
                .panel-title {
                    padding: 0 0 15px 0;
                    line-height: 100%;
                    &>span {
                        padding: 0 5px;
                        color: #666;
                        border-right: 6px solid #999;
                    }
                }
                table {
                    border-top: 2px solid #009DD9;
                    border-left: 1px solid #ddd;
                    width: 100%;
                    text-align: center;
                    border-collapse: 0;
                    th {
                        color: #2A3C59;
                        background: #F2F2F2;
                        padding: 10px;
                    }
                    td {
                        color: #6A707D;
                        padding: 5px;
                        height: 35px;
                    }
                    th, td{
                        border-bottom: 1px solid #ddd;
                        border-right: 1px solid #ddd;
                    }
                }
            }
        }
        #message {
            background: #F8F8F8;
            padding: 0 0 20px 0;
            &>.container {
                width: 1000px;
                margin: auto;
                border-radius: 4px 4px 0 0;
                box-shadow: 3px 3px 5px #a0a0a0, -2px -2px 5px #eee;
                &>h2 {
                    padding: 20px;
                    line-height: 100%;
                    color: #2A3C59;
                    &>a {
                        float: right;
                        font-weight: 400;
                        font-size: 14px;
                        color: #2A3C59;
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
                &>.message-body {
                    border-top: 1px solid #ccc;
                    padding: 5px 500px 5px 10px;
                    color: #333;
                    &>.scroll-message {
                        float: right;
                        width: 500px;
                        margin-right: -500px;
                        padding: 0 20px;
                    }
                    &>img {
                        max-width: 200px;
                        float: left;
                        margin: 0 20px 0 10px;
                    }
                    &>h2 {
                        color: #333;
                        padding: 10px;
                    }
                    &>p {
                        font-size: 13px;
                    }
                }
            }
        }
        #scrollBox2 {
            height: 120px;
            overflow: hidden;
            &>.scrollWrap {
                &>.scrollPanel {
                    &>li {
                        position: relative;
                        font-size: 14px;
                        vertical-align: middle;
                        line-height: 25px;
                        white-space: nowrap;
                        display: inline-block;
                        padding-left: 15px;
                        &:before {
                            content: '•', ;
                            color: #009DD9;
                            position: absolute;
                            font-size: 25px;
                            top: 2px;
                            left: 0;
                        }
                        &>a {
                            text-decoration: none;
                            color: #999;
                            font-size: 12px;
                            &:hover {
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }
        }
    }
    .pagination{
        padding: 10px;
        text-align: right;
    }
    .scrollWrap2 {
        float: none;
        width: 100%;
        height: 50px;
        overflow: hidden;
        .scrollPanel {
            float: none !important;
            li {
                float: none;
                display: block !important;
            }
        }
    }
    section {
        height: 450px;
        padding-top: 50px;
    }
    section header {
        background: rgba(0, 0, 0, .5);
    }
    .login-panel .m-card-bordered{
        border: none;
        background: rgba(0,0,0,.5);
    }
    section .login-container .login-panel-head {
        color: #FFF;
        border-color: #FFF;
    }
    section .login-container .login-panel-head .logo {
        border-color: #FFF;
        background-color: #FFF;
    }
    section .login-container .login-panel-links a {
        color: #FFF;
    }
    .index-news-layout {
        width: 1040px;
    }
    .index-news-layout .item {
        padding: 0 20px;
        width: 345px;
    }
    .pix-card-bordered {
        background: rgba(0, 0, 0, .5);
        border: none;
    }
</style>
